import { useEffect } from "react";
import { useLocation } from "react-router-dom";


export const useFieldHashNavigation = (loading: boolean) => {
  const { hash } = useLocation();

  useEffect(() => {
    // Don't try to scroll if the form is still loading or there's no hash
    if (loading || !hash) return;

    // Remove the # and try to find the element
    const elementId = hash.slice(1);
    const element = document.getElementById(elementId);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [hash, loading]);
};